import bootbox from "../../../../vendor/assets/javascripts/limitless_kit/plugins/notifications/bootbox.min";

globalThis.bootbox = bootbox;
